import styled from "@emotion/styled"
import Image from "components/media/ImageCLD"
import Video, { cssContainer, cssVideo } from "components/media/VideoCLD"
import { cssVars } from "components/nav-v2/Wrapper"
import VideoLauncher from "components/video-launcher/VideoLauncher"
import { useConsole } from "contexts/Console"

const Root = styled.section`
  --offset: 2px;

  place-items: center;
  display: grid;
  position: relative;

  > * {
    grid-area: 1 / 1;
  }

  .${cssContainer} {
    width: 100%;
  }

  img,
  picture,
  .${cssVideo} {
    display: block;
    height: calc(100svh - var(${cssVars.main.safe}) + var(--offset));
    object-fit: cover;
    object-position: center;
  }
`

const CTA = styled(VideoLauncher)``

export default function VideoPlayer({ content, theme = "dark-theme" }) {
  const console = useConsole()

  const asset = content.find(item => item.asset)?.asset

  const image = asset?.asset?.filter(item => item.resource_type === "image") || []
  const video = asset?.asset?.filter(item => item.resource_type === "video") || []

  const videoPlayer = content.find(item => item.video_player)?.video_player

  console.log("TestimoneeVideoPlayer(%o)", { image, video, videoPlayer })

  return (
    <Root className={theme}>
      {image.length > 0 && <Image loading='lazy' sources={image} alt={asset?.alt ?? ""} sizes='100vw' />}
      {video.length > 0 && <Video autoPlay loop muted noButton sources={video} className={cssVideo} sizes='100vw' />}
      <CTA video_player_cld={videoPlayer} className={videoPlayer.style ?? "filled translucent-dark"} />
    </Root>
  )
}
